export default {
  base: '/',
  login: '/login',
  authenticate: '/authenticate',
  unauthorizedGenesis: '/unauthorized-application',
  forbidden: '/forbidden',
  forbiddenAccess: '/forbidden-access',
  notAuthorized: '/not-authorized',
  blockedAddress: '/blocked-address',
  error: '/error',
  authError: '/auth-error',
  logout: '/logout',
  unauthorized: '/unauthorized-application',

  home: '/home',
  dashboard: '/dashboard',
  activity: '/mainatenance/activities',
  maintenance: '/maintenance/:tabName',
  locations: '/maintenance/:tabName/:subTabName',
  activityEntryExit: '/mainatenance/:tabName/:subTabName',
  audit: '/audits/:tabName',

  gemini: '/gemini/:tabName',

  userAndRoles: '/user-role/:tabName',
  addRoleAndPermissions: '/user-role/role-permissions/add',
  modifyRoleAndPermissions: '/user-role/role-permissions/modify/:roleId',

  nominations: '/nominations/:tabName',
  nominationsHistory: '/nominations/:tabName/:subTabName',

  senseCheck: '/sense-check/:tabName',

  trade: '/trade/:tabName',

  cva: '/cva/:tabName',

  summaryReports: '/summary-reports/:tabName',
};
